import { render, staticRenderFns } from "./SalesOrderDocumentsPage.vue?vue&type=template&id=b7eaedae&scoped=true"
import script from "./SalesOrderDocumentsPage.vue?vue&type=script&lang=js"
export * from "./SalesOrderDocumentsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7eaedae",
  null
  
)

export default component.exports